import { addFloatNumber, isSMAManagerFeeExcluded } from '../../../../utils/utils';

export default {
  name: 'total-fee-helper-mixin',
  computed: {
    totalFeeSchedule() {
      const newFeeSchedule = {
        ...this.schedule,
        feeScheduleId: this.currentFeeScheduleId,
      };
      let feeScheduleDetails = this.historicManagerFee;
      if (this.isHistoricManagerFee && this.schedule?.isMaxFee) {
        // program fee is flat max fee, manager fee is historic
        feeScheduleDetails = feeScheduleDetails.map(timeSchedule => {
          const appliedProgramFee = this.hasUserInputAnnualFee
            ? this.annualMaxFee
            : this.schedule.maxFee;
          return {
            ...timeSchedule,
            programFee: this.schedule.maxFee,
            totalAnnualMaxFee: addFloatNumber([this.schedule.maxFee, timeSchedule.managerFee]),
            totalAnnualFee: addFloatNumber([appliedProgramFee, timeSchedule.managerFee]),
          };
        });
      } else {
        /** program fee is historic max fee, manager fee is either flat or historic, backend should provide correct 'maxFee' value */
        ({ feeScheduleDetails = [] } = this.schedule ?? {});
        feeScheduleDetails = feeScheduleDetails.map(timeSchedule => {
          let managerFee = this.managerFee || 0;
          if (this.isHistoricManagerFee) {
            const historicTimeSchedule = this.historicManagerFee.find(
              ts => ts.start === timeSchedule.start && ts.end === timeSchedule.end
            );
            managerFee = historicTimeSchedule?.managerFee;
          }
          const appliedProgramFee = this.hasUserInputAnnualFee
            ? this.annualMaxFee
            : timeSchedule.maxFee;
          return {
            ...timeSchedule,
            managerFee,
            programFee: timeSchedule.maxFee,
            totalAnnualMaxFee: addFloatNumber([timeSchedule.maxFee, managerFee]),
            totalAnnualFee: addFloatNumber([appliedProgramFee, managerFee]),
          };
        });
      }
      return {
        ...newFeeSchedule,
        feeScheduleDetails,
      };
    },
    totalFeeScheduleDetails() {
      return this.totalFeeSchedule?.feeScheduleDetails;
    },
    totalAnnualFeeName() {
      if (this.totalFeeSchedule && !isSMAManagerFeeExcluded(this.totalFeeSchedule)) {
        // all-in program fee
        return this.totalFeeSchedule.name;
      }
      return this.feeName;
    },
  },
};
